import { render, staticRenderFns } from "./bannerPage.vue?vue&type=template&id=61129516&scoped=true&"
import script from "./bannerPage.vue?vue&type=script&lang=js&"
export * from "./bannerPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61129516",
  null
  
)

export default component.exports